"use client"

import React from "react"
import { motion } from "framer-motion"
import { ThemeToggle } from "@/components/theme-toggle"
import { GridIcon, HomeIcon } from "lucide-react"

export interface NavItem {
    name: string
    ref: React.RefObject<HTMLElement | null>
    id: string
}

export interface NavbarProps {
    activeSection: string
    scrollToSection: (ref: React.RefObject<HTMLElement | null>) => void
    navItems: NavItem[]
}

export function Navbar({ activeSection, scrollToSection, navItems }: NavbarProps) {
    return (
        <motion.nav
            initial={{ y: -100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="fixed top-0 left-0 right-0 z-50 flex items-center w-screen px-6 py-4 backdrop-blur-md bg-background/80 border-b"
        >
            <div className="flex items-center justify-center w-full md:w-[10%]">
                <div className="flex gap-2">
                    <HomeIcon className="text-emerald-600"></HomeIcon>
                    <span
                        className="text-xl font-bold tracking-tighter text-emerald-600  dark:text-emerald-600 uppercase">Quoc Bui</span>
                </div>
            </div>
            <div className="hidden md:flex items-center justify-center space-x-8 w-[80%]">
                {navItems.map((item) => (
                    <motion.button
                        key={item.name}
                        onClick={() => scrollToSection(item.ref)}
                        className={`relative px-1 py-2 text-lg font-medium transition-colors ${activeSection === item.id ? "text-primary" : "text-muted-foreground hover:text-foreground"
                            }`}
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        {item.name}
                        {activeSection === item.id && (
                            <motion.div
                                layoutId="activeSection"
                                className="absolute bottom-0 left-0 right-0 h-0.5 bg-emerald-400"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ duration: 0.2 }}
                            />
                        )}
                    </motion.button>
                ))}
            </div>

            <div className="hidden md:flex justify-end w-[10%]"><ThemeToggle /></div>
        </motion.nav>
    )
}